import { showErrorToast } from "src/components/AlertToastify/AlertToastify";

export const getSuperFunction = async (authId, userDataPlatform, leagueIdPlatform, pocToken, accessAuthToken, signal?: AbortSignal, yahooToken?: string): Promise<any> => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_URL}/functions/async-progreso`;

    const requestData = {
      league_integration: {
        pocToken: pocToken,
        leagueToken: userDataPlatform.integration_name === "yahoo" ? yahooToken : userDataPlatform.token,
        user_id: userDataPlatform.user_id,
        league_id: leagueIdPlatform,
        integration_name: userDataPlatform.integration_name,
      },
      response_settings: {
        persona_input: "standard",
        // max_words: 0,
        response_type: "markdown",
        super_prompt: true,
      },
      model: "RotoGPT 5.0",
    };

    console.log("superFunction REQUEST DATA", requestData);

    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessAuthToken}`,
      },
      body: JSON.stringify(requestData),
      signal,
      credentials: "include",
    });
    if (!response.ok) {
      // throw new Error("Request failed");
      const errorData = await response.json();
      const errorMessage = errorData.detail || errorData.message;
      throw new Error(errorMessage);
    }
    // const data = await response.json();
    // console.log("superFunction RESPONSE DATA", data);

    // return data;
    return response; // Return the response to be handled as a stream
  } catch (error) {
    if (error.name === "AbortError") {
      // Handle abort silently
      console.log("Request was aborted");
      return;
    }
    console.error("Error in getSuperFunction:", error);
    showErrorToast(error.message);
    throw error;
  }
};
